import { render } from "./EmergencyMedicine.vue?vue&type=template&id=7335366f&scoped=true"
import script from "./EmergencyMedicine.vue?vue&type=script&lang=ts"
export * from "./EmergencyMedicine.vue?vue&type=script&lang=ts"

import "./EmergencyMedicine.vue?vue&type=style&index=0&id=7335366f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7335366f"

export default script